import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../api.js";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [status, setStatus] = useState("loading");
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    setStatus("loading");
    try {
      const response = await api.get("/api/auth/me");
      setUser(response.data);
      setStatus("authenticated");
      return response.data;
    } catch {
      setUser(null);
      setStatus("unauthenticated");
      return null;
    }
  }, []);

  useEffect(() => {
    // 公開ログイン画面では未認証が正常なため /api/auth/me を呼ばない。
    // ログイン成功後は各ログイン画面が refresh() を明示的に呼ぶ。
    const publicPaths = new Set(["/", "/login/host", "/reset-password"]);
    if (publicPaths.has(window.location.pathname)) {
      setStatus("unauthenticated");
      return;
    }
    refresh();
  }, [refresh]);

  return (
    <AuthContext.Provider value={{ status, user, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
